// ---------------------------------------------------------------------------
// Session helpers shared by the chat adapter and the conversation provider.
// ---------------------------------------------------------------------------

// Provisioning a copilot sandbox for a fresh session takes ~20s, so as soon as
// the panel opens we ask the backend to warm it while the user is still
// typing. POST /copilot/session only schedules provisioning (202, no LLM turn,
// nothing added to the conversation), so it never has to be awaited and can't
// race the first real message.
const WARMUP_TIMEOUT_MS = 15_000;

export function buildCopilotHeaders(sessionId) {
  const token = localStorage.getItem('token');
  const workspaceId = localStorage.getItem('workspace_id');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (workspaceId) headers['workspace-id'] = workspaceId;
  if (sessionId) headers['X-Session-ID'] = sessionId;
  return headers;
}

export function startSessionWarmup(narrativeId, sessionId) {
  fetch('/API/v2/copilot/session', {
    method: 'POST',
    headers: buildCopilotHeaders(sessionId),
    body: JSON.stringify({ narrative_id: narrativeId }),
    signal: AbortSignal.timeout(WARMUP_TIMEOUT_MS),
  }).catch(() => {
    // Warm-up is best-effort: a failure just means the first real message
    // pays the cold-start cost, exactly as before.
  });
}
